import { createContext, useState } from 'react';

const GlobalContext = createContext({
    isShowModal: false,
    modalInfo: null,
    showModal: (modalInfo) => { },
    hideModal: () => { },
    setLayoutModel: (model) => { },
    layoutModel: null
});

export function GlobalContextProvider(props) {
    const [isShowModal, setIsShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [layoutModel, setLayoutModel] = useState(null);

    function showModalHandler(modalInfo) {
        setModalInfo(modalInfo);
        setIsShowModal(true);
    }

    function hideModalHandler() {
        setIsShowModal(false);
    }

    function setLayoutModelHandler(model) {
        setLayoutModel(model);
    }

    const context = {
        isShowModal: isShowModal,
        modalInfo: modalInfo,
        showModal: showModalHandler,
        hideModal: hideModalHandler,
        setLayoutModel: setLayoutModelHandler,
        layoutModel: layoutModel
    };

    return (
        <GlobalContext.Provider value={context}>
            {props.children}
        </GlobalContext.Provider>
    );
}

export default GlobalContext;